import React from 'react';

import css from './About.module.scss';

export default function Article({title, description, img, link}) {
  return (
    <li className={css.article}>
      <a href={link} target="_blank" rel="noopener noreferrer">
        <img src={img}  alt={title} />
        <div className={css.articleMeta}>
          <p>{description}</p>
          <h4>{title}</h4>
        </div>
      </a>
    </li>
  )
}
